import { render } from "./TextShimmerWave.vue?vue&type=template&id=b2d20f1a&scoped=true"
import script from "./TextShimmerWave.vue?vue&type=script&lang=js"
export * from "./TextShimmerWave.vue?vue&type=script&lang=js"

import "./TextShimmerWave.vue?vue&type=style&index=0&id=b2d20f1a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2d20f1a"]])

export default __exports__